import type {
  AgentConfigStatus,
  NotificationRuleState
} from '@axilon-apps/domains-ontology-ui-state'
import type { Status } from '../../../components/primitives/types'

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString()
  } catch {
    return iso
  }
}

export function formatFrequency(ms: number): string {
  if (ms < 60_000) return `${ms} ms`
  const min = Math.round(ms / 60_000)
  if (min < 60) return `every ${min} min`
  const hours = ms / 3_600_000
  if (hours < 48) return `every ${Number(hours.toFixed(1))} h`
  return `every ${Math.round(hours / 24)} d`
}

export function agentConfigStateToStatus(state: AgentConfigStatus): Status {
  switch (state) {
    case 'active':
      return 'run'
    case 'paused':
      return 'warn'
    case 'archived':
      return 'idle'
  }
}

export function customAgentTitleStatus(input: {
  state: AgentConfigStatus
  gateOnUnreviewedFindings?: boolean
  unreviewedFindingsCount?: number
}): { status: Status; label: string } {
  if (
    input.state === 'active' &&
    input.gateOnUnreviewedFindings === true &&
    (input.unreviewedFindingsCount ?? 0) > 0
  ) {
    return { status: 'warn', label: 'waiting on review' }
  }
  return { status: agentConfigStateToStatus(input.state), label: input.state }
}

export function notificationRuleStateToStatus(state: NotificationRuleState): Status {
  switch (state) {
    case 'active':
      return 'run'
    case 'disabled':
      return 'idle'
  }
}
